import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import { Link, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'

export const query = graphql`
  {
    prismic {
      allTools(sortBy: name_DESC) {
        edges {
          node {
            name
            logo
            description
            _meta{
              type
              uid
            }
          }
        }
      }
    }
  }
`
const toolsPage = ({ data }) => (
  <div className="body">
    <Layout>
      <SEO title="Tools" />
      <div className="grid-child intro">
        <div className="text-wrapper">
          <h1>Tools.</h1>
          <p className="page-paragraph"><strong>‍</strong>Because my internship was technical, I’ve written outlines on the tools I used, brief summaries on my progress with them, and resulting projects. </p>
          <p className="page-paragraph">For example I designed this blog with <Link to="/tools/webflow">Webflow</Link>, converted it into a progeressive web app with <Link to="/tools/gatsby">Gatsby</Link>, injected it with content using <Link to="/tools/prismic">Prismic</Link>, and finally launched this blog with <Link to="/tools/netlify">Netlify</Link> :)</p>
          <p className="page-paragraph">Throughout the <Link to="/timeline">Timeline</Link> I will reference these pieces of my new and improved web-development tech stack.</p>
        </div>
      </div>
      <div className="grid-child nopadding">
        <div className="card-parent grid">
          {data.prismic.allTools.edges.map(({ node: tool }, i) => (
            <Link to={linkResolver(tool._meta)} key={i} className="no-decoration">
              <div className="card ingrid tool w-inline-block">
                <img src={tool.logo.url} className="tool-logo" alt="tool" />
                <div className="card-label tool">
                  <h4 className="card-title">{tool.name[0].text}</h4>
                  <div>{tool.description[0].text}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  </div>
)
export default toolsPage